import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Attribute } from 'utils';

interface PaginatedApiResponse {
    data: Array<Attribute>;
    links: any; // Replace 'any' with the actual type of 'links'
    meta: any; // Replace 'any' with the actual type of 'meta'
}

type ReturnTypeCollection = Promise<AxiosResponse<PaginatedApiResponse>>;

const getAttributesForOrganization = (
    organizationUuid: string,
    params?: {
        per_page?: number;
        page?: number;
        name?: string;
        type?: string;
        category?: string;
        sub_category?: string;
        sort?: string;
    },
): ReturnTypeCollection => {
    return Request.get(`/attributes/${organizationUuid}`, {
        params: {
            per_page: params?.per_page,
            page: params?.page,
            'filter[name]': params?.name,
            'filter[type]': params?.type,
            'filter[category]': params?.category,
            'filter[sub_category]': params?.sub_category,
            sort: params?.sort,
        },
    });
};

export default getAttributesForOrganization;
